export const proPlanFeatures = [
    'Advanced AI models (GPT-5, Claude, Gemini)',
    'Multimodal advanced RAG (Up to 10 000 pages)',
    'Slide Studio - AI-powered design',
    'SharePoint connector',
    'Custom Agents - Wizard Builder',
    'Saved Prompts & Prompt Catalog',
    'Single Sign-On (SSO) & Azure AD'
];

export const enterprisePlanFeatures = [
    'Up to 10 000 docs (500 000 pages)',
    'Dedicated customer success',
    'Priority access to new features',
    'Tailor-made saved prompts',
    'On-premise deployment'
];
